import React, { useState, useEffect } from "react";
import {
  CardElement, 
  useStripe, 
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,

} from '@stripe/react-stripe-js';
import {Actions as PAYMENTACTIONS} from '../../store/actions/paymentActions';
import {connect} from 'react-redux';

const CARD_OPTIONS = {
  hidePostalCode: true,
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: '#666',
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {color: '#666'},
      '::placeholder': {color: '#666'},
    },
    invalid: {
      iconColor: 'red',
      color: 'red',
    },
    valid: {
      iconColor: 'green',
      color: 'green',
    },
  },
};

const CheckoutForm = ({
  stripePromise,
  processingStripeCharge,
  paymentIntent,
  invoiceNo,
  onSubmit,

  businessDetails,
  selectedBundle,
    customer,
  stripeCustomerID,

  stripeIntent,
  getStripeIntent,
  getStripePaymentMethods,
  clearBundle,
  cancelNewCard,
  setSavingCard,
  processStripeCharge,
  createStripeCharge,
  savingCard,
  hasPaymentMethods,
}) => {


  const on3DSComplete = async (intent,secret) => {
    // Check the PaymentIntent

    // should normally not wait as it would have already resolved
    const stripe = await stripePromise;

    stripe.retrievePaymentIntent(secret)
      .then(function(result) {
        console.log('result.paymentIntent',result.paymentIntent)

        if (result.error) {
          // PaymentIntent client secret was invalid
        } else {
          if (result.paymentIntent.status === 'succeeded') {
            // Show your customer that the payment has succeeded

            // send redux action to save intent as succeeded
            processStripeCharge({
              paymentIntentID: intent,
              bundle: selectedBundle,
              customerDetails: customer
            })


          } else if (result.paymentIntent.status === 'requires_payment_method') {
            // Authentication failed, prompt the customer to enter another payment method
          }
        }
      });
  }

  // const [sidebarOpen, setSidebarOpen] = useState(false)
  useEffect(() => {
    getStripeIntent({
      amount: selectedBundle.price * 100 * 1.18,
      currency: "EUR"
    })

    window.addEventListener('message', function(ev) {
      if (ev.data["3DS"] == true) {
        on3DSComplete(ev.data.intent,ev.data.secret);
      }
    }, false);
  },[selectedBundle]);


  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    if (savingCard){
      // already saving
      return
    }

    // submit parent form eg to save personal details
    onSubmit && onSubmit()

    console.log('handleSubmitCard')

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    setSavingCard(true)

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    // const {error, paymentMethod} = await stripe.createPaymentMethod({
    //   type: 'card',
    //   card: cardElement,
    // });
    // 
    const clientSecret = stripeIntent

    console.log('clientSecret',clientSecret)

    const savedCard = await stripe
      .confirmCardPayment(clientSecret, {
      // .confirmCardSetup(clientSecret, {
        payment_method: {
          card: cardElement,
          // billing_details: {
          //   name: 'Jenny Rosen',
          // },
        },
      })

      console.log('savedCard',savedCard);
      if(savedCard && savedCard.setupIntent && savedCard.setupIntent.payment_method){
        createStripeCharge(savedCard && savedCard.setupIntent && savedCard.setupIntent.payment_method)
      } else {
        if (savedCard.paymentIntent){
            console.log('savedCard.paymentIntent',savedCard.paymentIntent)
            processStripeCharge({
              paymentIntentID: savedCard.paymentIntent.id,
              bundle: selectedBundle,
              customerDetails: customer
            })
        }
        setSavingCard(false)
      }

      // charge the card
  };



  if (paymentIntent && paymentIntent.status == "requires_action"){
    return (
      <div
        style={{
            minWidth: "28rem",
          //   maxWidth: 600,
          width: "100%",
        }}>
        <iframe 
          src={paymentIntent.next_action.redirect_to_url.url}
          // width={600}
          height={400}
        />
      </div>
    )
  }

  return (

      <div className="">
        
        <div className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          style={{
          }}>
          <CardElement options={CARD_OPTIONS} />
        </div>
        

        <div className="mt-5">
          <a className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out"
            onClick={handleSubmit} 
            style={{marginTop: 10}}>
            {!savingCard && !processingStripeCharge && 
              <i 
                className={"fa fa-lock"} 
                style={{
                cursor: "pointer",
                  marginLeft: 0,
                  top: 0,
                  marginRight: 5,
                  color: "white",
                }}>
              </i>
            }
            {
                processingStripeCharge ? 
                  <React.Fragment>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing Payment
                  </React.Fragment> :
                    savingCard ? 
                      <React.Fragment>
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Saving your Card
                      </React.Fragment>
                      :
                      `PAY € ${selectedBundle.price * 1.18} incl. VAT`
            }
          </a>


          <a
            className="mt-3 text-sm inline-block"
            onClick={() => hasPaymentMethods ? cancelNewCard() : clearBundle()}
            style={{
              cursor: "pointer",
              padding: "6px 0",
              color: "#999",
              cursor: "pointer",
              textAlign: "center",
              width: "100%"
            }}>
            Cancel
          </a>
        </div>
        
      </div>
  );
};

const mapStateToProps = (state) => {

    // const offerBundle = {
    //   name: "250 Credits",
    //   price: 500,
    //   bonusCredits: "2021 Unlimited ",
    // }


    return {

      businessDetails: state.payment.stats && state.payment.stats.businessDetails,
      // selectedBundle: state.payment.selectedBundle,
      stripeCustomerID: state.payment.stats && state.payment.stats.stripeCustomerID,
      savingCard: state.payment.stripe.savingCard,
      hasPaymentMethods: state.payment.stripe && state.payment.stripe.paymentMethods && state.payment.stripe.paymentMethods.length > 0,
      stripeIntent: state.payment.stripe.intent && state.payment.stripe.intent.client_secret,
      processingStripeCharge: state.payment.stripe && state.payment.stripe.processingCharge,
      paymentIntent: state.payment.stripe && state.payment.stripe.paymentIntent,
      invoiceNo: state.payment.invoiceNo,
    
  }
}

const mapDispatchToProps = dispatch => ({
  getStripeIntent: ({amount,currency}) => dispatch(PAYMENTACTIONS.getStripePublicIntent({amount,currency})),
  processStripeCharge: ({paymentIntentID,bundle,customerDetails}) => dispatch(PAYMENTACTIONS.processStripeCharge({paymentIntentID,bundle,customerDetails})),
  createStripeCharge: (paymentMethodID) => dispatch(PAYMENTACTIONS.createStripeCharge(paymentMethodID)),


  // getStripePaymentMethods: () => dispatch(PAYMENTACTIONS.getStripePaymentMethods()),
  clearBundle: () => dispatch(PAYMENTACTIONS.selectBundle(null)),
  cancelNewCard: () => dispatch(PAYMENTACTIONS.addNewCard(false)),
  setSavingCard: (status) => dispatch(PAYMENTACTIONS.savingNewCard(status)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutForm) 
